import { css } from '@emotion/react'
import styled from '@emotion/styled'
import makeStyles from '@mui/styles/makeStyles'

export const usePopoverStyles = makeStyles(() => ({
  popover: {
    pointerEvents: 'none',
    maxHeight: 500,
  },
  popoverContent: {
    pointerEvents: 'auto',
  },
}))

export const CommentContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 10px 0 5px 0;
`

export const Message = styled.div`
  word-break: break-all;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
`

export const paper = css`
  padding: 12px 16px;
  min-width: 325px;
  max-width: 325px;
`

export const bold = css`
  font-weight: bold;
`

export const smallerFont = css`
  font-size: 11px;
`

export const editButton = css`
  margin-right: 5px;
`
